
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 120.334 15"}, attrs),
              ...rest,
            },
            children.concat([_c('text',{attrs:{"font-family":"'Montserrat-SemiBold'","font-size":"13.534","transform":"translate(-.378 12.238)"}},[_v('HSE')]),_c('text',{attrs:{"font-family":"'Montserrat-Regular'","font-size":"13.534","transform":"translate(30.327 12.238)"}},[_v('ALLIANCE')]),_c('path',{attrs:{"d":"M119.039 4.098c-.04-.073-.08-.147-.121-.219l-.955.523h.001l-.011.006-.02.011-2.67 1.465-.647.341-.975-2.182v-.008l-.132-.282a.753.753 0 00-.627-.326h-.917l.63 1.518.796 1.927-.574.303-1.121.596-.341.188.001-.004-.003.004h-.002l.069-.166-.064.162.354-.864.244-.596a.553.553 0 00-.018-.07l.003-.003-.003-.001c-.084-.287-.377-.499-.725-.499a.78.78 0 00-.607.278l-.137.309-.047.108-1.559 3.49h1.613l3.45-1.948.215.517.588 1.432h1.621l-1.184-2.646 2.991-1.688.301-.171c.198.611.301 1.253.301 1.902 0 3.39-2.76 6.15-6.152 6.15s-6.152-2.76-6.152-6.15a6.158 6.158 0 016.152-6.151c1.25 0 2.446.371 3.47 1.073l-.48.518 1.754-.064-.063-1.754-.437.47a7.225 7.225 0 00-4.243-1.365c-4.011 0-7.275 3.263-7.275 7.274s3.265 7.273 7.275 7.273c4.012 0 7.274-3.262 7.274-7.273a7.272 7.272 0 00-.841-3.408z"}})])
          )
        }
      }
    